import { DashboardData as Constants } from "../constants";

const initialState = {
  data: null,
};

export function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DASHBOARD_DATA:
      return {
        ...state,
        data: action.payload,
      };

    default:
      return state;
  }
}
